const table = () => ({
  table: { type: Object, required: true }
});
const thead = () => ({
  head: { type: Object, required: true }
});
const tbody = () => ({
  body: { type: Object, required: true }
});
const tr = () => ({
  row: {
    type: Object,
    required: true
  }
});
const th = () => ({
  cell: { type: Object, required: true }
});
const td = () => ({
  cell: { type: Object, required: true }
});
export {
  table,
  tbody,
  td,
  th,
  thead,
  tr
};
//# sourceMappingURL=getTableComponentProps.js.map
